<template>
  <div class="m-1">
    <b-row class="d-flex justify-content-between">
      <b-col md="" class="rounded mr-1 p-2" style="background-color: #ddddff">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">SITES</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" to="Site">Sites</b-link></h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.sites }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" to="Building">Buildings</b-link></h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.buildings }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/site.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
        
      </b-col>
      <b-col md="" class="rounded mr-1 p-2" style="background-color: #fdf2d6">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">OCCUPANTS</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" @click="viewResident()">Residents</b-link></h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.resident }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" @click="viewVisitor()">Contractors</b-link></h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.visitor }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/resident.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="" class="rounded mr-1 p-2" style="background-color: #d7f6e6">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">ALERTS</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5
                >
                  <b-link :class="{'text-dark font-weight-bolder': true, 'blinking-text': counts.fire_count > 0}" @click="viewFireAlarm(active)">
                    Fire Alerts
                  </b-link>
                </h5>
              </b-col>
              <b-col md="4">
                <h5 :class="{'text-dark font-weight-bold': true, 'blinking-text': counts.fire_count > 0}">{{ counts.fire_count }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" @click="viewFireAlarm(false_alarm)">False Alarms</b-link></h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.false_alarm_count }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/liveAlert.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="" class="rounded mr-1 p-2" style="background-color: #ffddd1">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">PEEPs</h2>
            <b-row>
              <b-col md="9" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" @click="viewPermPeep()">Permanent PEEPs</b-link></h5>
              </b-col>
              <b-col md="3">
                <h5 class="text-dark font-weight-bold">{{ counts.perm_peeps_count }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder"><b-link class="counter-text" @click="viewTempPeep()">Temporary PEEPs</b-link></h5>
              </b-col>
              <b-col md="3">
                <h5 class="text-dark font-weight-bold">{{ counts.temp_peeps_count }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/peep.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
        
      </b-col>
    </b-row>
    <b-row class="mt-2 match-height">
      <b-col md="5" class="p-0">
        <b-card class="p-0">
          <div id="map" style="height: 500px" class="m-0"></div>
        </b-card>
      </b-col>
      
      <b-col md="3" >
        <b-card class="p-0">
          <h4 class="font-weight-bolder text-dark text-center">
            Building Compliance Meter
          </h4>
          <div class="mt-2">
            <h6><b-link to="/emergency_scenario_drill">Emergency Scenario Drill (%)</b-link></h6>
            <b-progress
              :value="counts.esd_count"
              :max="counts.sites"
              show-progress
              variant="danger"
              animated
              height="1.5rem"
            >              
            </b-progress>
          </div>
          <div class="mt-2">
            <h6><b-link to="/site">Staff Trained (%)</b-link></h6>
            <b-progress
              :value="counts.total_trained"
              :max="counts.total_staff"
              variant="info"
              show-progress
              animated
              height="1.5rem"
            >
            </b-progress>
          </div>
          <div class="mt-2">
            <h6><b-link to="/equipment_report">Equipment Report (%)</b-link></h6>
            <b-progress
              :value="counts.equipment_report_count"
              :max="counts.sites"
              show-progress
              variant="success"
              animated
              height="1.5rem"
            >
            </b-progress>
          </div>
          <div class="mt-2">
            <h6><b-link to="/evacuation_diagram">Evacuation Diagram (%)</b-link></h6>
            <b-progress
              :value="counts.evacuation_diagram_count"
              :max="counts.floors"
              show-progress
              variant="warning"
              animated
              height="1.5rem"
            >
            </b-progress>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" >
        <b-card class="p-0">
          <h4 class="font-weight-bolder text-dark text-center">
            Overall Compliance
          </h4>
          <div id="chart" class="text-center mt-1">
            <!-- Changed from apexchart to apexdonut -->
            <apexchart
              type="donut"
              :options="chartOptions"
              :series="series"
              :key="chartKey"
            ></apexchart>
          </div>
        </b-card>
      </b-col>
      <!-- <b-col md="12">
        <b-card class="">
          <b-card-header class="m-0 p-0">
            <div>
              <h4 class="font-weight-bolder text-dark m-0 p-0">
                Notifications
              </h4>
            </div>
            <div>
              <span class="font-weight-bolder text-primary m-0 p-0">
                see all
              </span>
              <feather-icon
                icon="ArrowRightCircleIcon"
                class="text-primary mr-50"
                size="22"
              />
            </div>
          </b-card-header>
        </b-card>
      </b-col> -->
    </b-row> 
      
    <ViewResidentModal
      @modalClosed="onModalClosed"
      :key="`viewResident-${viewResidentModalCount}`"
    />

    <ViewVisitorModal
      @modalClosed="onModalClosed"
      :key="`viewVisitor-${viewVisitorModalCount}`"
    />

    <ViewPermPeepModal
      @modalClosed="onModalClosed"
      :key="`viewPermPeep-${viewPermPeepModalCount}`"
    />

    <ViewTempPeepModal
      @modalClosed="onModalClosed"
      :key="`viewTempPeep-${viewTempPeepModalCount}`"
    />
    <ViewFireAlarmModal
      @modalClosed="onModalClosed"
      :key="`viewFireAlarm-${viewFireAlarmModalCount}`"
      :alarm_type="alarm_type"
    />
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { mapActions, mapGetters } from "vuex";
import ViewResidentModal from "@/components/dashboard/ViewResidentModal.vue"
import ViewVisitorModal from "@/components/dashboard/ViewVisitorModal.vue"
import ViewPermPeepModal from "@/components/dashboard/ViewPermPeepModal.vue"
import ViewTempPeepModal from "@/components/dashboard/ViewTempPeepModal.vue"
import ViewFireAlarmModal from "@/components/dashboard/ViewFireAlarmModal.vue"
import { Loader } from "@googlemaps/js-api-loader";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Pusher from 'pusher-js';

export default {
  components: {
    apexchart: VueApexCharts,
    ViewResidentModal,
    ViewVisitorModal,
    ViewPermPeepModal,
    ViewTempPeepModal,
    ViewFireAlarmModal,
  },
  data() {
    return {
      counts: "",
      viewResidentModalCount: 0,
      viewVisitorModalCount: 0,
      viewPermPeepModalCount: 0,
      viewTempPeepModalCount: 0,
      viewFireAlarmModalCount: 0,
      active: "active",
      false_alarm: "false_alarm",
      alarm_type: "",
      chartKey: 1,
      series: [],
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        labels: ["Approved", "Rejected", "Pending", "Left"],
        colors: [
          "#215673",
          "#a4c7e0",
          "#3bc4a2",
          "#eb9605",
          "#b80716",
          "#3c80b5",
          "#2f9999",
          "#90EE90",
        ],
        legend: {
          show: true,
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "top",
                offsetY: 10, // Adjust if necessary
              },
            },
          },
        ],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  formatter: (w) => {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  },
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
      },
      locations: [],
    };
  },
  async mounted() {
    try {

      // Configure Pusher with your credentials
      const pusher = new Pusher('88e8f2c4534814d9c03f', {
        cluster: 'mt1'
      });

      const userId = this.getLoggedInUser.id;
      const channelName = `my-channel-${userId}`;
      const channel = pusher.subscribe(channelName);

      // Bind to an event
      channel.bind('my-event', async (data) => {
        const counter = await this.getCounter();
        this.counts = counter.data;
        // this.$toast(
        //   {
        //     component: ToastificationContent,
        //     props: {
        //       title: "Fire Alert!!", 
        //       variant: "danger",
        //       icon: "AlertTriangleIcon",
        //     },
        //   },
        //   {
        //     position: "top-right",
        //   }
        // );
      });


      const counter = await this.getCounter();
      this.counts = counter.data;

      const sites = await this.getBuildingsDDL();
      this.buildings = sites.data;
      this.locations = this.buildings
        .filter(location => location.latitude !== null && location.longitude !== null)
        .map(location => ({ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude), name: location.name }));

      const loader = new Loader({
        apiKey: "AIzaSyAXVVZ5v2Uu5OmIEEF2JVDOZjcAQtj5WDw",
        version: "weekly",
      });

      const google = await loader.load();
    
    const australiaBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(-38.5, 144.5),
      new google.maps.LatLng(-37.0, 145.5)
    );

    const map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: -25.2744, lng: 133.7751 }, // Center to Australia
      zoom: 5, // Adjust zoom level as needed
      minZoom: 3,
      maxZoom: 18,
      restriction: {
        latLngBounds: australiaBounds,
        strictBounds: false
      },
    });

    this.locations.forEach(location => {
      new google.maps.Marker({
        position: { lat: location.lat, lng: location.lng },
        map: map,
        title: location.name,
      });
    });

    // Ensure the map bounds are applied
    map.fitBounds(australiaBounds);

    } catch (error) {
      console.error("Error initializing map:", error);
    }
  },
  watch: {
    counts(newCounts) {
      if (newCounts.donut_counter) {
        this.series = newCounts.donut_counter;
        this.chartKey++; 
      }
    },
  },
  methods: {
    ...mapActions({
      getCounter: "appData/getCounter",
      getBuildingsDDL: "appData/getBuildingsDDL",
    }),

    viewResident() {
      this.viewResidentModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-resident-modal");
      });
    },

    viewVisitor() {
      this.viewVisitorModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-visitor-modal");
      });
    },

    viewPermPeep() {
      this.viewPermPeepModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-perm-peep-modal");
      });
    },

    viewTempPeep() {
      this.viewTempPeepModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-temp-peep-modal");
      });
    },
    viewFireAlarm(alarm_type) {
      this.alarm_type = alarm_type;
      this.viewFireAlarmModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-fire-alarm-modal");
      });
    },
    async onModalClosed() {
      const counter = await this.getCounter();
      this.counts = counter.data;
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style scoped>
#map {
  height: 100%;
}
.counter-text {
  color: black;
}
.counter-text:hover {
  color: #febc03;
}
.blinking-text {
  animation: blinking 1s infinite;
  color: red !important;
}

@keyframes blinking {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>